module.exports = __webpack_public_path__ + "static/img/ms-symbollockup_signin_dark.b23fe02.svg";